import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loyaltyPoints: 0,
};

const loyaltySlice = createSlice({
    name: 'Loyalty',
    initialState,
    reducers: {
        setLoyaltyPoints(state, action) {
            state.loyaltyPoints = action.payload;
        },
    },
});

export const { setLoyaltyPoints } = loyaltySlice.actions;

export const selectLoyaltyPoints = (state) => state.loyalty.loyaltyPoints;

export default loyaltySlice.reducer;
